import { createAction } from 'redux-actions';
import BrothersMember from '../utils/BrothersMember/BrothersMember'

export const indexBorthersMember = createAction('INDEX_BROTHERS_MEMBER',BrothersMember.index)
export const setIndexBrothersMember = createAction('SET_INDEX_BROTHERS_MEMBER')
export const setSHOWBrothersMember = createAction('SET_SHOW_BROTHERS_MEMBER')
export const createBrothersMember= createAction('CREATE_BROTHERS_MEMBER',BrothersMember.create)
export const newBrothersMember = createAction('NEW_BROTHERS_MEMBER',BrothersMember.new)
export const destroyBrothersMember = createAction('DESTROY_BROTHERS_MEMBER',BrothersMember.destroy)




// WEBPACK FOOTER //
// ./src/dashboards_redux/actions/BrothersMemberAction.jsx